'use strict';
/**
 * 引导JS: redux + react 初始化 （connect是异步操作）
 */

import React from 'react';
import ReactDom from 'react-dom';
import {applyMiddleware, createStore} from 'redux';
import thunk from 'redux-thunk';
import {Provider} from 'react-redux';

import reducerApp from '@redux/reducer/detail'; // TODO

import Detail from '@pages/detail.jsx';

// import Form from '@redux/container/detail';
// import Result from '@redux/container/detail';
import {BrowserRouter as Router, Route, Link} from 'react-router-dom';

import KNB from '@dp/knb';
import Util from '@common/js/util';

import RLU from 'rlu';
import './assets/styles/global.less'; // TODO

let store = createStore(
    reducerApp,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
    applyMiddleware(thunk)
);

/**
 * TODO: 
 * detail、apply、save页使用SPA，无跳转刷新，状态连续变化由前端控制（注意点：router保证回退；apply -> save页必须jumpToScheme/replace）
 * 与列表页通讯（状态变更），APP: publish+subscribe; M站: 页面跳转/回退强制刷新
 */

class BootStrap {
    constructor(props) {
        RLU.init(375);
    }

    init() {
        try {
            // if (!Util.isApp('dpapp')) {
            //     var metas = document.getElementsByTagName("meta");
            //     for (var i=0; i<metas.length; i++) {
            //         if (metas[i].getAttribute("name") && metas[i].getAttribute("name")==="lx:appnm") {
            //             metas[i].setAttribute("content", Util.isApp('mtgroup') ? "group" : "dp_m");
            //         }
            //     }
            // }
            // LXAnalytics('pageView', null, null, 'c_r95jj7ne');
            Util.getCity().then((cityid) => {
                LXAnalytics('pageView', {"custom": {
                    "city_id": cityid || 1,
                    "pageview": Util.getUA() || {},
                    "event_id": Util.parseQuery('offlineActivityId')
                }}, null, 'c_r95jj7ne');
            }, (err) => {
                LXAnalytics('pageView', {"custom": {
                    "city_id": 1,
                    "pageview": Util.getUA() || {},
                    "event_id": Util.parseQuery('offlineActivityId')
                }}, null, 'c_r95jj7ne');
            })
        } catch (e) {
            console.log('lx page view error')
        }
        if (Util.isApp()) {
            // 禁止反弹
            KNB.ready(function () {
                KNB.setBouncesEnabled({
                    enable: 0,
                    success: function () {}
                });
            });
        }

        ReactDom.render(
            <Provider store={store}>
                {/*<Router>
                    <Route path="/" component={Detail}/>*/}
                    {/*<Route path="/apply" component={Index}/>
                    <Route path="/save" component={Index}/>*/}
                {/*</Router>*/}
                <Detail/>
            </Provider>, document.getElementById('app')
        );
    }
}

new BootStrap().init();


// WEBPACK FOOTER //
// ./src/pages/detail_bootstrap.jsx